module.exports = "/_next/static/images/Frame2Mobile-0477e02adb719f215dc00c192d6ac0ab.webp";